module.exports = __webpack_public_path__ + "components/signup-page/static/icon-eye--hide-13a99b3d67f78c99139382aef7f3d229.svg";